'use strict';

import React, {Component} from 'react';

class SupressUserError extends Component {
    emptyList = [];
    state = {
        //Initiate Default User
        codeValue: "",
        pwd: "",
        error: "",
        value: "",
        newBoxValue: "",
        oldBoxValue: "",
        amountPayment: 0,
        idPayment: ""
    }
    componentDidMount = () => {}
    componentWillUnmount = () => {}
    onClickHandle = async() => {
        var methodName = "onClickHandle"
        console.log("[INFO], onClickHandle, ")

        try {
            const res = await fetch("/admin/supress/info", {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                body: JSON.stringify({
                    action: this.state.value,
                    pwd: this.state.pwd,
                    codeValue: this.state.codeValue,
                    newBoxValue: this.state.newBoxValue,
                    oldBoxValue: this.state.oldBoxValue,
                    amountPayment: this.state.amountPayment,
                    idPayment: this.state.idPayment
                }),
                credentials: 'same-origin'
            });
            let infos = await res.json();
            console.log({infos});

            if (infos.error != 'OK') {
                console.log("[ERROR] submit supression reception ", infos.error);
                this.setState({error: ""})
            } else {
                this.setState({codeValue: "", pwd: ""})
            }
        } catch (err) {
            console.log("[ERROR] submit supression ", err);
            this.setState({error: err})
        }
    }
    render() {
        console.log('[INFO], render fonction Main PAYG');
        return (
            <div className="container">
                <div className="card">
                    <div className="card-header">
                        <h1>
                            <select
                                onChange={(event) => {
                                this.setState({value: event.target.value});
                            }}
                                value={this.state.value}>
                                <option value="">--Please choose an option--</option>
                                <option value="supressBox">Supprimer box avant Paiement</option>
                                <option value="supressPayment">Supress Payment</option>
                                <option value="switchBox">Changer Box</option>
                            </select>
                        </h1>
                    </div>

                    {this.state.value === "supressPayment"
                        ? <div>
                                <div className="form-group">
                                    <div className="fg-line">
                                        <input
                                            type="text"
                                            className="form-control input-sm"
                                            placeholder="ID Payment"
                                            onChange={(e) => {
                                            this.setState({idPayment: e.target.value})
                                        }}
                                            value={this.state.idPayment}/>
                                    </div>
                                </div>
                                <div className="form-group">
                                    <div className="fg-line">
                                        <input
                                            type="number"
                                            className="form-control input-sm"
                                            placeholder="Montant"
                                            onChange={(e) => {
                                            this.setState({amountPayment: e.target.value})
                                        }}
                                            value={this.state.amountPayment}/>
                                    </div>
                                </div>
                            </div>
                        : <div></div>}
                    {this.state.value === "supressBox"
                        ? <div>
                                <div className="form-group">
                                    <div className="fg-line">
                                        <input
                                            type="text"
                                            className="form-control input-sm"
                                            placeholder="ID User"
                                            onChange={(e) => {
                                            this.setState({codeValue: e.target.value})
                                        }}
                                            value={this.state.codeValue}/>
                                    </div>
                                </div>
                                <div className="form-group">
                                    <div className="fg-line">
                                        <input
                                            type="password"
                                            className="form-control input-sm"
                                            placeholder="Password"
                                            onChange={(e) => {
                                            this.setState({pwd: e.target.value})
                                        }}
                                            value={this.state.pwd}/>
                                    </div>
                                </div>
                            </div>
                        : <div></div>}

                    {this.state.value === "switchBox"
                        ? <div>
                                <div className="form-group">
                                    <div className="fg-line">
                                        <input
                                            type="text"
                                            className="form-control input-sm"
                                            placeholder="Old Box"
                                            onChange={(e) => {
                                            this.setState({oldBoxValue: e.target.value})
                                        }}
                                            value={this.state.oldBoxValue}/>
                                    </div>
                                </div>
                                <div className="form-group">
                                    <div className="fg-line">
                                        <input
                                            type="text"
                                            className="form-control input-sm"
                                            placeholder="New Box"
                                            onChange={(e) => {
                                            this.setState({newBoxValue: e.target.value})
                                        }}
                                            value={this.state.newBoxValue}/>
                                    </div>
                                </div>
                            </div>
                        : <div></div>}

                    <div className="btn-demo">
                        <button className="btn btn-success waves-effect" onClick={this.onClickHandle}>Request Modification</button>
                    </div>
                    {this.state.error}
                </div>
            </div>
        );
    }
};
export default SupressUserError;
